// extracted by mini-css-extract-plugin
export default {"toast":"App_toast__db878","toast-body":"App_toast-body__CFKNq"};